import type { VxChartCalendarIntensityLevel } from '@voxie/frontend-components';

const STRIPED_SVG_PATH = 'M-1,1 l2,-2 M0,7 l7,-7 M6,8 l2,-2';

const buildStripedSvgUrl = (stroke: string): string => {
    const svg = `<svg width='7' height='7' xmlns='http://www.w3.org/2000/svg'><path d='${STRIPED_SVG_PATH}' stroke='${stroke}' stroke-width='1'/></svg>`;
    return `url("data:image/svg+xml,${encodeURIComponent(svg)}")`;
};

export const stripedStrokeColors: Record<string, string> = {
    default: 'rgba(226, 232, 240, 0.8)',
    '50': 'rgba(186, 230, 253, 0.8)',
    '200': 'rgba(255, 255, 255, 0.5)',
    '400': 'rgba(255, 255, 255, 0.4)',
    '600': 'rgba(255, 255, 255, 0.3)',
    '700': 'rgba(255, 255, 255, 0.2)',
    '900': 'rgba(255, 255, 255, 0.2)',
    past: 'rgba(226, 232, 240, 0.8)',
};

export const getStripedBackgroundStyle = (intensity: VxChartCalendarIntensityLevel) => {
    const stroke = stripedStrokeColors[intensity] ?? stripedStrokeColors['default'] ?? 'rgba(226, 232, 240, 0.8)';

    return {
        backgroundImage: buildStripedSvgUrl(stroke),
        backgroundRepeat: 'repeat',
    };
};

export const stripedLegendStyle = {
    backgroundImage: buildStripedSvgUrl('rgba(255, 255, 255, 0.5)'),
};
